<template>
  <div class="i-order">
    <div class="up">
      <!-- 我的订单 -->
      <div class="facab">
        <div class="fac">
          <div
            class="oText"
            @click="getOrderListclick(-1)"
            :class="{ active: orderChoose == -1 }"
          >
            {{ $t('main.all') }}({{ allTotal }})
          </div>
          <div
              class="oText"
              @click="getOrderListclick(-2)"
              :class="{ active: orderChoose == -2 }"
          >
            {{ $t('main.productBuild') }}({{ customTotal }})
          </div>
          <div
            class="oText"
            @click="getOrderListclick(0)"
            :class="{ active: orderChoose == 0 }"
          >
            {{ $t('main.ToBePaid') }}({{ wzhfTotal }})
          </div>
          <div
            class="oText"
            @click="getOrderListclick(4)"
            :class="{ active: orderChoose == 4 }"
          >
            {{ $t('main.Completed') }}({{ ypjywcTotal }})
          </div>
        </div>
        <div
          class="tEnd color-80"
          @click="getOrderListclick(8)"
          :class="{ active: orderChoose == 8 }"
        >
          {{ $t('main.Deleted') }}({{ deleteTotal }})
        </div>
      </div>
    </div>
    <div class="down">
      <div class="fac tHeader">
        <div class="oDetail">{{ $t('main.OrderList') }}</div>
        <div class="oP">{{ $t('main.consignee') }}</div>
        <div v-if="orderChoose!='-2'" class="oT">{{ $t('main.amountOfMoney') }}</div>
        <div v-if="orderChoose!='-2'" class="oT">{{ $t('main.Status') }}</div>
        <div class="oP">{{ $t('main.Manage') }}</div>
      </div>
      <div v-for="(item, index) in orderList" :key="index">
        <div class="otime facab">
          <div class="fac">
            <div> {{ $t('main.OrderNumber') }}：{{ item.sn }}</div>
          </div>
          <div class="sTime">{{ $t('main.OrderDate') }}：{{ handleTimeToString(item.create_time) }}</div>
          <!-- <div class="sTime">剩余支付时间：01时52分10秒</div> -->
        </div>
        <div class="fac tContent">
          <div class="oDetail fac">
            <img style="cursor: pointer;" @click="gotoProductDetail(item.sn_product_list[0])" :src="item.sn_product_list[0].thumb" class="pImg" />
            <div class="ml20">
              <div class="fac">
                <div style="width: 12rem">{{ $t('main.totalNum') }}</div>
                <div style="width: calc(100% - 12rem);">X {{ item.total_number }}</div>
              </div>
              <div class="fac" v-if="item.order_type==='1'">
                <div style="width: 12rem">{{ $t('main.product') }}</div>
                <div style="width: calc(100% - 12rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item.sn_product_list[0])">{{ item.sn_product_list[0].type_name }}</div>
              </div>
              <div class="fac">
                <div v-if="item.order_type==='1'" style="width: 12rem">{{ $t('main.partNumber') }}</div>
                <div v-if="item.order_type==='1'" style="width: calc(100% - 12rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item.sn_product_list[0])">{{ item.sn_product_list[0].product_model }}</div>
                <div v-if="item.order_type==='2'" style="width: 12rem">{{ $t('main.productBuild') }}</div>
                <div v-if="item.order_type==='2'" style="width: calc(100% - 12rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item.sn_product_list[0])">{{ item.sn_product_list[0].type_name }}</div>
              </div>
              <div
                class="fac  color-999"
                v-for="(itemps, index) in item.sn_product_list[0].product_data"
                v-if="itemps.isShow"
                :key="index"
              >
                <div style="width: 12rem">{{ itemps.title }}</div>
                <div style="width: calc(100% - 12rem);">{{ itemps.value }}</div>
              </div>
              <div
                  class="fac  color-999"
                  v-for="(itemps, index) in item.sn_product_list[0].product_data"
                  v-if="item.order_type==='2' || (!itemps.isShow && showMore.findIndex(res=>{return res == item.id;}) > -1)"
                  :key="index"
              >
                <div style="width: 12rem">{{ itemps.title }}</div>
                <div style="width: calc(100% - 12rem);">{{ itemps.value }}</div>
              </div>
              <div v-if="item.order_type==='1'" class="fac color-635796" style="cursor: pointer;" @click="handleProductParamsMore(item)">
                {{ showMore.findIndex(res=>{return res == item.id;}) > -1 ? $t('main.Cut') : $t('main.More') }}
                <i :class="showMore.findIndex(res=>{return res == item.id;}) > -1 ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
              </div>
            </div>
          </div>
          <div class="oP oCenter">
            <div class="cCtext">
              {{ item.address_info.receive_user }}
            </div>
          </div>
          <div v-if="orderChoose!='-2'" class="oT oCenter">
            <div class="cCtext" v-if="item.order_type==='1'">{{ $t('main.monetaryUnit') }}{{ (Math.round( (parseFloat(item.total_price) + parseFloat(item.freight_price)) * 100)/100).toFixed(2) }}</div>
            <div class="cCtext" v-if="item.order_type==='2'">/</div>
          </div>
          <div v-if="orderChoose!='-2'" class="oT oCenter">
            <div class="cCtext">
              <span class="color-999" v-if="item.order_type==='1' && item.pay_type!=='4'">
                {{ chagePaysattus(item.status) }}
              </span>
              <span class="color-999" v-else>
                /
              </span>
            </div>
          </div>
          <div class="oP oCenter">
            <div class="cCtext">
              <el-button
                v-if="item.status == '0' && item.order_type==='1' && item.pay_type!=='4'"
                class="mb20"
                @click="detailOrder(0, item.sn)"
                type="danger"
              >
                {{ $t('main.PayNow') }}
              </el-button>
              <div @click="gotoDetail(item.sn)">
                {{ $t('main.orderDetail') }}
              </div>
              <div class="mt20"  v-if="item.status === '0' && item.order_type==='1' && item.pay_type!=='4'" @click="detailOrder(1, item.sn)">
                {{ $t('main.delete') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="!orderList.length"> {{ $t('main.noData') }}</div>
    </div>
    <div class="pagination">
      <el-pagination
          layout="prev, pager, next"
          hide-on-single-page
          :total="total"
          :current-page="page"
          :page-size="limit"
          @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {listOrder, deleteOrder, suregetGood, cancelgood} from '@/api/order'
import {getProductInfo} from "@/api";
import Cookies from "js-cookie";

export default {
  props: ['searchParam'],
  data() {
    return {
      orderChoose: -1,
      orderList: [],
      //一次全部查询出来因为还要知道各种订单的数量   "0|未支付,1|已支付，未发货,2|已发货，未收货,3|已收货，未评价,4|已评价，已完成,8|已删除,9|已取消",
      wzhfList: [], //未支付
      yzfwfhList: [], //已支付未发货
      yfhwshList: [], //已发货未收获
      yshwpjList: [], //已收获，未评价
      ypjywcList: [], //已收货，已完成
      deleteList: [], //已删除
      quxiaoList: [], //已取消
      allList: [], //全部订单
      customList: [], //定制订单
      //一次全部查询出来因为还要知道各种订单的数量   "0|未支付,1|已支付，未发货,2|已发货，未收货,3|已收货，未评价,4|已评价，已完成,8|已删除,9|已取消",
      wzhfTotal: 0, //未支付
      yzfwfhTotal: 0, //已支付未发货
      yfhwshTotal: 0, //已发货未收获
      yshwpjTotal: 0, //已收获，未评价
      ypjywcTotal: 0, //已收货，已完成
      deleteTotal: 0, //已删除
      quxiaoTotal: 0, //已取消
      allTotal: 0, //全部订单
      customTotal: 0, //定制订单
      page: 1, // 当前页码
      limit: 5, // 一页展示几条
      total: 0, // 总条数
      showMore: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    }
  },
  watch: {
    orderChoose: function(newV) {
      this.$emit('statusChange', newV)
    },
    "$store.state.siteInfo": function(newV) {
      if (newV) {
        this.init();
      }
    }
  },
  computed: {

  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // "options": "0|未支付,1|已支付，未发货,2|已发货，未收货,3|已收货，未评价,4|已评价，已完成,8|已删除,9|已取消",
      this.getOrderList(-1)
      //获取定制
      this.getOrderList(-2)
      this.getOrderList(0)
      this.getOrderList(4)
      this.getOrderList(8)
      // 获取当前择中
      this.getOrderListclick(this.orderChoose)
    },
    //到产品界面
    gotoProductDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    handleProductParamsMore(item) {
      let isExit = this.showMore.findIndex(res=>{
        return res == item.id;
      });
      if (isExit > -1) {
        this.showMore.splice(isExit, 1);
      } else {
        this.showMore.push(item.id);
      }
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    handleTimeToString(v) {
      // let date = new Date(parseInt(v) - 1000);
      // let Y = date.getFullYear();
      // let M = date.getMonth() + 1;
      // let D = date.getDate();
      // let H = date.getHours();
      // let m = date.getMinutes();
      // let s = date.getSeconds();
      // return `${Y}-${M}-${D} ${H}:${m}:${s}`;
      var chazhi = Cookies.get("Difference");
      var benditime = v*1000-chazhi;
      let date = new Date(benditime);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      M = M > 9 ? M : "0" + M;
      let D = date.getDate();
      D = D > 9 ? D : "0" + D;
      let H = date.getHours();
      H = H > 9 ? H : "0" + H;
      let m = date.getMinutes();
      m = m > 9 ? m : "0" + m;
      let s = date.getSeconds();
      s = s > 9 ? s : "0" + s;
      return `${Y}-${M}-${D} ${H}:${m}:${s}`;
    },
    gotoDetail(orderid) {
      // console.log(orderid)
      this.$router.push(
          {
            path: '/userCenter/orderdetail',
            query: { id: orderid }
          }
      )
    },
    chagePaysattus(statusvalue) {
      if (0 == statusvalue) {
        // return "待支付"
        return this.$t('main.ToBePaid')
      }

      if (1 == statusvalue) {
        // return "待发货"
        return this.$t('main.ToBeShipped')
      }

      if (2 == statusvalue) {
        // return "待收货"
        return this.$t('main.ToBeReceived')
      }

      if (4 == statusvalue) {
        // return "已完成"
        return this.$t('main.Completed')
      }

      if (8 == statusvalue) {
        // return "已删除"
        return this.$t('main.HasDeleted')
      }

      if (9 == statusvalue) {
        // return "已取消"
        return this.$t('main.Cancelled')
      }
    },

    //获取订单列表
    getOrderList(orderStatus) {
      var orderListParams = {}
      if (-1 == orderStatus) {
        orderListParams = {
          req: {
            page: this.page,
            limit: this.limit,
            where: this.searchParam
              ? [
                  {
                    condition: `%${this.searchParam}%`,
                    filed:
                      'sn|total_price|total_number|address_info|bill_info|bill_url|bill_status|logistics_company|logistics_numbers|note_message|pay_sn|sn_product_list',
                    expression: 'LIKE',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: '8',
                    filed: 'status',
                    expression: '<>',
                  },
                ]
              : [
                  {
                    condition: '8',
                    filed: 'status',
                    expression: '<>',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                ],
            order: 'id desc',
          },
        }
      } else if (-2 == orderStatus) {
        orderListParams = {
          req: {
            page: this.page,
            limit: this.limit,
            where: this.searchParam
                ? [
                  {
                    condition: `%${this.searchParam}%`,
                    filed:
                        'sn|total_price|total_number|address_info|bill_info|bill_url|bill_status|logistics_company|logistics_numbers|note_message|pay_sn|sn_product_list',
                    expression: 'LIKE',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: '8',
                    filed: 'status',
                    expression: '<>',
                  },
                  {
                    condition: '2',
                    filed: 'order_type',
                    expression: '=',
                  },
                ]
                : [
                  {
                    condition: '8',
                    filed: 'status',
                    expression: '<>',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: '2',
                    filed: 'order_type',
                    expression: '=',
                  },
                ],
            order: 'id desc',
          },
        }
      } else {
        orderListParams = {
          req: {
            page: this.page,
            limit: this.limit,
            where: this.searchParam
              ? [
                  {
                    condition: `%${this.searchParam}%`,
                    filed:
                      'sn|total_price|total_number|address_info|bill_info|bill_url|bill_status|logistics_company|logistics_numbers|note_message|pay_sn|sn_product_list',
                    expression: 'LIKE',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: `${orderStatus}`,
                    filed: 'status',
                    expression: '=',
                  },
                  {
                    condition: '1',
                    filed: 'order_type',
                    expression: '=',
                  },
                ]
              : [
                  {
                    condition: `${orderStatus}`,
                    filed: 'status',
                    expression: '=',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: '1',
                    filed: 'order_type',
                    expression: '=',
                  },
                ],
            order: 'id desc',
          },
        }
      }

      listOrder(orderListParams).then((res) => {
        if (orderStatus == 0) {
          this.wzhfList = res.data.list
          this.wzhfTotal = res.data.total
        }
        if (orderStatus == 1) {
          this.yzfwfhList = res.data.list
          this.yzfwfhTotal = res.data.total
        }
        if (orderStatus == 2) {
          this.yfhwshList = res.data.list
          this.yfhwshTotal = res.data.total
        }
        if (orderStatus == 3) {
          this.yshwpjList = res.data.list
          this.yshwpjTotal = res.data.total
        }
        if (orderStatus == 4) {
          this.ypjywcList = res.data.list
          this.ypjywcTotal = res.data.total
        }
        if (orderStatus == 8) {
          this.deleteList = res.data.list
          this.deleteTotal = res.data.total
        }
        if (orderStatus == 9) {
          this.quxiaoList = res.data.list
          this.quxiaoTotal = res.data.total
        }
        if (orderStatus == -1) {
          this.allList = res.data.list
          this.allTotal = res.data.total
        }
        if (orderStatus == -2) {
          this.customList = res.data.list
          this.customTotal = res.data.total
        }
        //
      })
    },
    //点击获取
    getOrderListclick(orderStatus)
    {
      if (this.orderChoose !== orderStatus) {
        this.page = 1
      }
      this.orderChoose = orderStatus
      var orderListParams = {}
      if (-1 == orderStatus) {
        orderListParams = {
          req: {
            page: this.page,
            limit: this.limit,
            where: this.searchParam
              ? [
                  {
                    condition: `%${this.searchParam}%`,
                    filed:
                      'sn|total_price|total_number|address_info|bill_info|bill_url|bill_status|logistics_company|logistics_numbers|note_message|pay_sn|sn_product_list',
                    expression: 'LIKE',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: '8',
                    filed: 'status',
                    expression: '<>',
                  },
                ]
              : [
                  {
                    condition: '8',
                    filed: 'status',
                    expression: '<>',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                ],
            order: 'id desc',
          },
        }
      } else if (-2 == orderStatus) {
        orderListParams = {
          req: {
            page: this.page,
            limit: this.limit,
            where: this.searchParam
                ? [
                  {
                    condition: `%${this.searchParam}%`,
                    filed:
                        'sn|total_price|total_number|address_info|bill_info|bill_url|bill_status|logistics_company|logistics_numbers|note_message|pay_sn|sn_product_list',
                    expression: 'LIKE',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: '8',
                    filed: 'status',
                    expression: '<>',
                  },
                  {
                    condition: '2',
                    filed: 'order_type',
                    expression: '=',
                  },
                ]
                : [
                  {
                    condition: '8',
                    filed: 'status',
                    expression: '<>',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: '2',
                    filed: 'order_type',
                    expression: '=',
                  },
                ],
            order: 'id desc',
          },
        }
      } else {
        orderListParams = {
          req: {
            page: this.page,
            limit: this.limit,
            where: this.searchParam
              ? [
                  {
                    condition: `%${this.searchParam}%`,
                    filed:
                      'sn|total_price|total_number|address_info|bill_info|bill_url|bill_status|logistics_company|logistics_numbers|note_message|pay_sn|sn_product_list',
                    expression: 'LIKE',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: `${orderStatus}`,
                    filed: 'status',
                    expression: '=',
                  },
                  {
                    condition: '1',
                    filed: 'order_type',
                    expression: '=',
                  },
                ]
              : [
                  {
                    condition: `${orderStatus}`,
                    filed: 'status',
                    expression: '=',
                  },
                  {
                    condition: Cookies.get("siteInfo"),
                    filed: "site_id",
                    expression: "="
                  },
                  {
                    condition: '1',
                    filed: 'order_type',
                    expression: '=',
                  },
                ],
            order: 'id desc',
          },
        }
      }
      listOrder(orderListParams).then((res) => {
        this.orderList = res.data.list
        this.total = res.data.total
      })
    },

    handleCurrentChange(val) {
      this.page = val
      this.getOrderListclick(this.orderChoose)
    },
    detailOrder(flag, sn){
      if(0==flag){
        //去支付
        this.$router.push({ path: '/purchase', query: { sn:sn } })
      }
      if(1==flag){
        //删除
        var params = {
          req: {
            sns: sn,
          },
        }
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        })
            .then(() => {
              deleteOrder(params).then((res) => {
                if (res.rsp.code == 0) {
                  this.init()
                  this.$message({
                    message: this.$t('main.operationCompletedSuccessfully'),
                    type: 'success',
                  })
                } else {
                  this.$message({
                    message: res.rsp.msg,
                    type: 'error',
                  })
                }
              })
            })
            .catch(() => {})
      }

      if(2==flag){
        // 取消
        var params = {
          req: {
            sns: sn,
          },
        }

        var params = {
          req: {
            sns: sn,
          },
        }
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        })
            .then(() => {
              cancelgood(params).then((res) => {
                if (res.rsp.code == 0) {
                  this.init()
                  this.$message({
                    message: this.$t('main.operationCompletedSuccessfully'),
                    type: 'success',
                  })
                } else {
                  this.$message({
                    message: res.rsp.msg,
                    type: 'error',
                  })
                }
              })
            })
            .catch(() => {})
        //取消
      }
      if(3==flag){
        //确认收货
        var params = {
          req: {
            sns: sn,
          },
        }
        this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
          confirmButtonText: this.$t('main.sure'),
          cancelButtonText: this.$t('main.cancel'),
          type: 'warning',
        })
            .then(() => {
              suregetGood(params).then((res) => {
                if (res.rsp.code == 0) {
                  this.init()
                  this.$message({
                    message: this.$t('main.operationCompletedSuccessfully'),
                    type: 'success',
                  })
                } else {
                  this.$message({
                    message: res.rsp.msg,
                    type: 'error',
                  })
                }
              })
            })
            .catch(() => {})
      }
    }
  },
}
</script>

<style scoped lang="less">
.i-order {
  min-height: 46.25rem;
  background: #fafafa;
  border: 1px solid #e5e5e5;
  .up {
    width: 100%;
    height: 4.375rem;
    background: #f2f2f2;
    border-bottom: 1px solid #e5e5e5;
    line-height: 4.375rem;
    .tEnd {
      width: 15%;
      text-align: center;
      cursor: pointer;
    }
    .oText {
      color: #1a1a1a;
      font-size: 0.9rem;
      margin-left: 1.5rem;
      cursor: pointer;
    }
    .active {
      color: #635796 !important;
    }
  }
  .down {
    max-height: calc(46.25rem - 12.375rem);
    overflow-y: auto;
    .no-data {
      width: 100%;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }
    .tHeader {
      height: 4.375rem;
      line-height: 4.375rem;
      color: #1a1a1a;
    }
    .otime {
      height: 4.375rem;
      line-height: 4.375rem;
      background-color: #f2f2f2;
      color: #999999;
      padding: 0 1.875rem 0 1.5rem;
    }
    .tContent {
      padding: 1rem 0;
      border: 1px solid #e6e6e6;
      border-radius: 0.5rem;
      .pImg {
        width: 7.5rem;
      }
      .oCenter {
        display: flex;
        /deep/ .el-button--danger {
          background-color: #635796;
          border-color: #635796;
        }
        .cCtext {
          div {
            cursor: pointer;
          }
        }
      }
      .cCtext {
        margin: auto;
      }
    }
    .oDetail {
      min-width: 50%;
      padding-left: 1.5rem;
    }
    .oT {
      min-width: 10%;
      height: 100%;
      border-left: 1px solid #e5e5e5;
      text-align: center;
    }
    .oP {
      min-width: 15%;
      width: 30%;
      height: 100%;
      border-left: 1px solid #e5e5e5;
      text-align: center;
    }
    .ml20 {
      margin-left: 0.5rem;
    }
    .mt10 {
      margin-top: 0.625rem;
    }
    .mb20 {
      margin-bottom: 1.25rem;
    }
    .mt20 {
      margin-top: 0.5rem;
    }
    .color-999 {
      color: #999999;
    }
    .pagination {
      width: 100%;
      text-align: center;
      margin: 0.5rem 0;
    }
  }
  .color-80 {
    color: #808080;
  }

  /deep/ .el-pager li {
    background: #fff;
    margin: 0.1rem;
  }
  /deep/ .el-pagination {
    text-align: center;
  }
  /deep/ .el-pagination button:hover,.el-pagination button:focus,.el-pagination button:active {
    color: #635796;
  }
  /deep/ .el-pager li.active {
    background: #635796;
    color: #fff!important;
  }
  /deep/ .el-pager li:hover {
    background: #635796;
    color: #fff!important;
  }
}
</style>
